<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'
import { richTextImgHandler } from '@/utils/common'

export default {
  name: 'Comp28',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini')
    }
  },
  methods: {
    getShadowColor, getPageThemeColor, richTextImgHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-28">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-28-content pointer">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-28-${v.id}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        class="item"
        :class="{'martop': i % 2 !== 0}"
        @click="onModuleItem(v)"
      >
        <div class="item-content">
          <p class="divider">{{ `${admini}退役军人服务站` }}</p>
          <p class="item-title">{{ v.headline || '' }}</p>
          <p class="rich-text" v-html="richTextImgHandler(v.memo)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.modules-id-28 {
  .rich-text {
    p {
      font-size: 10px !important;
      line-height: 20px !important;
      // transform: scale(0.9);
    }
  }
}
</style>
<style lang="scss" scoped>
.modules-id-28-content {
  height: 100%;
  display: flex;
  column-gap: 20px;
  align-items: flex-start;
}
.item {
  width: 164px;
  height: 246px;
  border-radius: 5px;
  background: url('~imgs/modules/module-28-bg.webp') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
}
.martop {
  margin-top: 44px;
}
.item-content {
  width: 133px;
  height: 196px;
  box-sizing: border-box;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .divider {
    width: 100%;
    text-align: center;
    font-size: 9px;
    transform: scale(.6);
    font-family: siyuansong;
    font-weight: 800;
    color: #E57474;
    &::before {
      content: '';
      width: 13px;
      height: 1px;
      background: #E57474;
      position: absolute;
      top: 11px;
      right: 0;
      bottom: 0;
      left: -16px;
    }
    &::after {
      content: '';
      width: 13px;
      height: 1px;
      background: #E57474;
      position: absolute;
      top: 11px;
      right: 0;
      bottom: 0;
      left: 136px;
    }
  }
  .item-title {
    min-width: 88px;
    // min-height: 30px;
    background: #E57474;
    border-radius: 2px;
    font-size: 10px;
    transform: scale(.8);
    font-family: siyuansong;
    font-weight: 800;
    color: #fff;
    line-height: 25px;
    padding: 4px 6px;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    margin-top: 4px;
  }
  .rich-text {
    width: 133px;
    display: block;
    margin-top: 8px;
  }
}
</style>
